


























import Vue from 'vue';
import { mapActions } from 'vuex';
import { BFormCheckbox } from 'bootstrap-vue';

import { ModalSize } from '@/components/zen_modal/types';
import GenericCard from '@/components/cards/GenericCard.vue';

export interface MessageRow {
  text: string;
  class: string;
}

export default Vue.extend({
  name: 'GenericDeleteCard',
  components: {
    GenericCard,
    BFormCheckbox,
  },
  props: {
    title: {
      type: String,
      default: 'You are about to delete an item',
    },
    message: {
      type: Array as () => (MessageRow | String)[],
      default: [{ text: 'Deleted objects can not be restored!', class: '' }],
    },
    confirmLabel: {
      type: String,
      default: 'OK, I understand',
    },
    okTitle: {
      type: String,
      default: 'Delete',
    },
  },
  data() {
    return {
      confirmed: false,
    };
  },
  computed: {
    messageRows() {
      return this.message.map(row => (typeof row === 'string' ? { text: row, class: '' } : row));
    },
  },
  created() {
    this.changeSize(ModalSize.Small);
  },
  methods: {
    ...mapActions({
      changeSize: 'modals/changeSize',
      confirmModal: 'modals/confirm',
      cancelModal: 'modals/cancel',
    }),
  },
});
